import { ButtonGroup, Flex, InputGroup } from "@chakra-ui/react";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PropertiesFilterPopover } from "src/routes/Properties/PropertiesFilterPopover";

export const PropertiesFilterBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const onSubmit = useCallback(
    (newSp: URLSearchParams) => {
      newSp.delete("pageNumber");
      searchParams.sort();
      newSp.sort();

      if (searchParams.toString() !== newSp.toString()) {
        navigate(`?${newSp.toString()}`);
      }
    },
    [searchParams]
  );

  return (
    <Flex flexDirection="row">
      {/* isolation causes other elements to ignore the popover's z-index; best to disable it */}
      <InputGroup isolation="unset">
        <ButtonGroup gap="8px">
          <PropertiesFilterPopover onSubmit={onSubmit} />
        </ButtonGroup>
      </InputGroup>
    </Flex>
  );
};
